import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

import {ContatosService} from "../services/contatos.service";
import {EnumTipoDeCartao} from "../../../server/lib/emun/EnumTipoDeCartao";
import {ActivatedRoute, Router} from "@angular/router";
import {DropDownFilterSettings} from "@progress/kendo-angular-dropdowns";
import {Location} from '@angular/common';
import {SelosComponent} from "../componentes/selo/selo.component";
import {AutorizacaoService} from "../services/autorizacao.service";
import {AcoesModulosComponent} from "../componentes/acoes-modulos/acoes-modulos.component";
import {NovoContatoComponent} from "../novo-contato/novo-contato.component";
import {EmpresasService} from "../superadmin/services/empresas.service";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {KendoPopupUtils} from "../lib/KendoPopupUtils";
import {FiadosService} from "../services/fiados.service";
import {ModalCreditoFiadoComponent} from "../fidelidade/modal-credito-fiado/modal-credito-fiado.component";
import {FormasDePagamentoService} from "../services/formas-de-pagamento.service";
import {ModalAcertoFiadoComponent} from "../fidelidade/modal-acerto-fiado/modal-acerto-fiado.component";
import {ConstantsService} from "../fidelidade/ConstantsService";

@Component({
  selector: 'app-contato-detalhes',
  templateUrl: './ver-contato.component.html',
  styleUrls: ['./ver-contato.component.scss']
})
export class VerContatoComponent implements OnInit {
  acoes: any = [];
  cartoes: any = [];
  filtro: any = {cartao: null};
  contato: any = {};
  @ViewChild('selosCartao', { static: true } ) selosCartao: SelosComponent;
  @ViewChild('acoesModulo', { static: true } ) acoesModulo: AcoesModulosComponent;
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains'
  };
  abraDialogo: boolean;
  telefone: any;
  documento: any;
  id: any;
  nomeContato: any;
  widget = false;
  usuario: any;
  ehGarcom: any;
  empresa: any;
  novaTag: any;
  tagSelecionada: any;
  tags = []
  respServerAlterouAtivarDesativar;
  buscandoTag = false;
  salvandoTag = false;
  carregandoHistoricoFinanceiro = false;
  carregouHistoricoFinanceiro = false;
  erroHistoricoFinanceiro = '';
  contaFinanceira: any = null;
  movimentosFinanceiros: any[] = [];
  carregandoHistoricoAcertos = false;
  carregouHistoricoAcertos = false;
  erroHistoricoAcertos = '';
  acertosFiado: any[] = [];
  carregandoLancamentosFiado = false;
  carregouLancamentosFiado = false;
  erroLancamentosFiado = '';
  lancamentosFiadoEmAberto: any[] = [];
  saldoDevedorFiado = 0;
  formasDePagamentoFiado: any[] = [];
  exibirFinanceiro = false;
  moduloFiado  = false;
  constructor(   private  contatosService: ContatosService, private router: Router,
               private dialogService: DialogService,  private  constantsService: ConstantsService,
               private activatedRoute: ActivatedRoute, private _location: Location,
               private autorizacaoService: AutorizacaoService, private empresasService: EmpresasService,
               private fiadosService: FiadosService,
               private formasDePagamentoService: FormasDePagamentoService) {

  }

  inIframe () {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  ngOnInit() {
    let usuarioLogado = this.autorizacaoService.getUser();

    if( usuarioLogado != null ){
      this.usuario = usuarioLogado;
      this.ehGarcom = this.usuario && this.usuario.garcom;
    } else {
      this.usuario = {};
    }

    this.empresa = this.usuario.empresa;

    this.constantsService.moduloFiado$.subscribe(moduloFiado => {
      this.moduloFiado = moduloFiado
    });


    this.buscandoTag = true;
    this.empresasService.listeTags().then((tags) => {
      this.tags = tags;
      this.buscandoTag = false;
    })


    this.activatedRoute.queryParams.subscribe(queryParams => {
      this.nomeContato = this.activatedRoute.snapshot.queryParams.nome;

      this.widget = this.inIframe();

      const { contato } = window.history.state;

      if (contato) {
        this.setContato(contato)
      }
      else {
        this.telefone =  this.activatedRoute.snapshot.params['zap'];
        this.documento =  this.activatedRoute.snapshot.params['documento'];
        this.id =  this.activatedRoute.snapshot.params['id'];
        this.carregueContato();
      }
    });
  }

  carregueContato(){
    if(this.id){
      this.contatosService.obtenhaContatoPorId(this.id).then( (contatoObtido: any) => {
        this.setContato(contatoObtido);
      });
    } else if(this.telefone){
      this.contatosService.obtenhaContato(this.telefone.toString()).then( (contatoObtido: any) => {
        this.setContato(contatoObtido);
      });
    } else {

      if(this.documento){
        this.contatosService.obtenhaContatoPorDocumento(this.documento.toString()).then( (contatoObtido: any) => {
          this.setContato(contatoObtido);
        });
      }
    }
  }

  editarContato(contato: any) {

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: NovoContatoComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.exibaContato(contato);

    windowRef.result.subscribe((result: any) => {
      if(result && result.id) {
        contato = Object.assign(contato, result);
      }
    } );

  }

  setContato(contato: any) {
    this.contato = contato || {};
    this.carregouHistoricoFinanceiro = false;
    this.erroHistoricoFinanceiro = '';
    this.erroHistoricoAcertos = '';
    this.contaFinanceira = this.contato.contaFinanceira || null;
    this.movimentosFinanceiros = [];
    this.acertosFiado = [];
    this.lancamentosFiadoEmAberto = [];
    this.saldoDevedorFiado = 0;
    this.erroLancamentosFiado = '';
    this.carregouHistoricoAcertos = false;
    this.carregouLancamentosFiado = false;

    if( !contato.id )     return;


    this.cartoes = contato.cartoes;
    this.cartoes.forEach( cartao => cartao.descricao = cartao.plano.nome)
    if(this.cartoes.length)
      this.filtro.cartao = this.cartoes[0];

   if(this.porSelos())
     this.selosCartao.setCartao(this.filtro.cartao)

    if(!this.contato.ultimasAcoes){
      this.carregueUltimasAcoes();
    } else {
      this.acoes = this.contato.ultimasAcoes
    }

    this.acoesModulo.contato = contato;

    if(this.moduloFiado){
      this.exibirFinanceiro =  this.contato?.contaFinanceira && !this.ehGarcom;

      if(this.exibirFinanceiro) {
        this.carregueHistoricoFinanceiro();
        this.carregueLancamentosFiadoEmAberto();
      }
    }
  }

  selecionouAbaHistorico(evento: any) {
    if(evento?.title === 'Histórico') {
      this.carregueUltimasAcoes()

    }
  }

  selecionouAbaFinanceiro(evento: any) {
    if(evento?.title === 'Histórico financeiro')
      this.carregueHistoricoFinanceiro();
    if(evento?.title === 'Histórico Acerto')
      this.carregueHistoricoAcertos();
  }

  carregueFormasDePagamentoFiado(): Promise<any[]> {
    this.formasDePagamentoFiado = [...(this.empresa?.formasDePagamento || [])];

    if(!this.formasDePagamentoFiado.length && this.empresa?.id) {
      return this.formasDePagamentoService.obtenhaFormasDePagamentos(this.empresa).then((formas: any[]) => {
        this.formasDePagamentoFiado = formas || [];
        return this.formasDePagamentoFiado;
      }).catch(() => this.formasDePagamentoFiado);
    }

    return Promise.resolve(this.formasDePagamentoFiado);
  }

  carregueHistoricoFinanceiro(forcar: boolean = false) {
    if(!forcar && (this.carregouHistoricoFinanceiro || this.carregandoHistoricoFinanceiro || !this.contato?.id)) return;
    if(forcar && (!this.contato?.id || this.carregandoHistoricoFinanceiro)) return;

    this.carregandoHistoricoFinanceiro = true;
    this.erroHistoricoFinanceiro = '';

    this.fiadosService.listeMovimentosConta(this.contato.id, {t: 500}).then((resposta: any) => {
      this.carregandoHistoricoFinanceiro = false;
      this.carregouHistoricoFinanceiro = true;
      this.contaFinanceira = resposta?.conta || this.contaFinanceira;
      this.movimentosFinanceiros = resposta?.movimentos || [];
    }).catch((erro: any) => {
      this.carregandoHistoricoFinanceiro = false;
      this.carregouHistoricoFinanceiro = true;
      this.erroHistoricoFinanceiro = erro || 'Erro ao carregar histórico financeiro.';
    });
  }

  carregueLancamentosFiadoEmAberto(forcar: boolean = false): Promise<void> {
    if(!forcar && (this.carregouLancamentosFiado || this.carregandoLancamentosFiado || !this.contato?.id)) return Promise.resolve();
    if(forcar && (!this.contato?.id || this.carregandoLancamentosFiado)) return Promise.resolve();

    this.carregandoLancamentosFiado = true;
    this.erroLancamentosFiado = '';

    return this.fiadosService.listeLancamentosCliente(this.contato.id, {t: 500}).then((resposta: any) => {
      this.carregandoLancamentosFiado = false;
      this.carregouLancamentosFiado = true;
      this.lancamentosFiadoEmAberto = (resposta?.lancamentos || [])
        .filter((item: any) => this.lancamentoFiadoEmAberto(item));
      this.saldoDevedorFiado = this.lancamentosFiadoEmAberto
        .reduce((total: number, item: any) => total + Number(item?.saldo || 0), 0);
    }).catch((erro: any) => {
      this.carregandoLancamentosFiado = false;
      this.carregouLancamentosFiado = true;
      this.erroLancamentosFiado = erro || 'Erro ao carregar saldo devedor do fiado.';
      this.lancamentosFiadoEmAberto = [];
      this.saldoDevedorFiado = 0;
    });
  }

  lancamentoFiadoEmAberto(lancamento: any) {
    const status = String(lancamento?.status || '').toLowerCase();
    return (status === 'aberto' || status === 'parcial') && Number(lancamento?.saldo || 0) > 0;
  }

  carregueHistoricoAcertos(forcar: boolean = false) {
    if(!forcar && (this.carregouHistoricoAcertos || this.carregandoHistoricoAcertos || !this.contato?.id)) return;
    if(forcar && (!this.contato?.id || this.carregandoHistoricoAcertos)) return;

    this.carregandoHistoricoAcertos = true;
    this.erroHistoricoAcertos = '';

    this.fiadosService.listeAcertos({idContato: this.contato.id, t: 500}).then((resposta: any) => {
      this.carregandoHistoricoAcertos = false;
      this.carregouHistoricoAcertos = true;
      this.acertosFiado = resposta?.acertos || [];
    }).catch((erro: any) => {
      this.carregandoHistoricoAcertos = false;
      this.carregouHistoricoAcertos = true;
      this.erroHistoricoAcertos = erro || 'Erro ao carregar histórico de acertos.';
    });
  }

  async abraModalCreditoFinanceiro() {
    if(!this.contato?.id) return;

    const formasDePagamento = await this.carregueFormasDePagamentoFiado();

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalCreditoFiadoComponent,
      width: window.innerWidth > 760 ? 700 : window.innerWidth - 20,
      maxHeight: window.innerHeight - 80,
      cssClass: 'bsModal'
    });

    const instancia: ModalCreditoFiadoComponent = windowRef.content.instance;
    instancia.window = windowRef;
    instancia.contato = this.contato;
    instancia.formasDePagamento = formasDePagamento || [];

    windowRef.result.subscribe((result: any) => {
      if(result && result.id) {
        this.carregouHistoricoFinanceiro = false;
        this.carregueHistoricoFinanceiro(true);
      }
    });
  }

  abraFiadosDoCliente(contato: any) {
    if(!contato?.id) return;

    this.router.navigate(['/admin/fiados'], {
      queryParams: {
        idContato: contato.id
      }
    }).then(() => {});
  }


  async abraModalAcertoFinanceiro() {
    if(!this.contato?.id || this.carregandoLancamentosFiado) return;

    await this.carregueFormasDePagamentoFiado();
    await this.carregueLancamentosFiadoEmAberto(true);

    if(!this.lancamentosFiadoEmAberto.length) {
      this.erroLancamentosFiado = 'Este cliente não possui fiados em aberto para acerto.';
      return;
    }

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalAcertoFiadoComponent,
      width: window.innerWidth > 1320 ? 1260 : window.innerWidth - 40,
      maxHeight: window.innerHeight - 80,
      cssClass: 'bsModal modal-acerto-fiado-dialog'
    });

    const instancia: ModalAcertoFiadoComponent = windowRef.content.instance;
    instancia.window = windowRef;
    instancia.contato = this.contato;
    instancia.lancamentos = this.lancamentosFiadoEmAberto.map((item: any) => ({...item}));
    instancia.formasDePagamento = this.formasDePagamentoFiado || [];

    windowRef.result.subscribe((result: any) => {
      if(result && result.id) {
        this.carregouHistoricoFinanceiro = false;
        this.carregouHistoricoAcertos = false;
        this.carregouLancamentosFiado = false;
        this.carregueHistoricoFinanceiro(true);
        this.carregueHistoricoAcertos(true);
        this.carregueLancamentosFiadoEmAberto(true);
      }
    });
  }

  obtenhaLabelTipoMovimento(tipo: string) {
    const texto = String(tipo || '').toLowerCase();
    if(texto === 'credito') return 'Crédito';
    if(texto === 'debito') return 'Débito';
    return tipo || '-';
  }

  obtenhaLabelOrigemMovimento(origem: string) {
    const texto = String(origem || '').toLowerCase();
    if(texto === 'credito_manual') return 'Crédito manual';
    if(texto === 'fiado') return 'Fiado';
    if(texto === 'acerto') return 'Acerto';
    if(texto === 'estorno') return 'Estorno';
    if(texto === 'ajuste') return 'Ajuste';
    return origem || '-';
  }

  obtenhaNomeOperadorMovimento(movimento: any) {
    const operador = movimento?.operador || movimento?.usuario || null;
    return operador?.nome || operador?.email || operador?.codigoPdv || '-';
  }

  obtenhaNomeOperadorAcerto(acerto: any) {
    const operador = acerto?.usuario || acerto?.operador || null;
    return operador?.nome || operador?.email || operador?.codigoPdv || '-';
  }

  movimentoEhCredito(movimento: any) {
    return String(movimento?.tipo || '').toLowerCase() === 'credito';
  }

  obtenhaClasseValorMovimento(movimento: any) {
    return this.movimentoEhCredito(movimento) ? 'valor-credito' : 'valor-debito';
  }

  obtenhaValorMovimentoSinalizado(movimento: any) {
    const valor = Number(movimento?.valor || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });

    return `${this.movimentoEhCredito(movimento) ? '+' : '-'}${valor}`;
  }

  carregueUltimasAcoes(){
    this.contatosService.obtenhaUltimasAcoes(this.contato).then( (acoes) => {
      this.contato.ultimasAcoes = acoes;
      this.acoes = this.contato.ultimasAcoes;
    })
  }

  adcionarPontos(contato: any) {
    this.router.navigateByUrl('/admin/contatos/pontos/adicionar' ,
      { state: { contato: contato, cartao: this.filtro.cartao } }).then( () => { });
  }


  trocarPontos(contato: any) {
    this.router.navigateByUrl('/admin/contatos/pontos/trocar' ,
      { state: { contato: contato, cartao: this.filtro.cartao } }).then( () => { });
  }

  alterouCartao(cartao) {
    if(cartao && cartao.plano.tipoDeAcumulo === EnumTipoDeCartao.Selos)
      this.selosCartao.setCartao(cartao)
  }

  porSelos() {
    return this.filtro.cartao && this.filtro.cartao.plano.tipoDeAcumulo === EnumTipoDeCartao.Selos;
  }

  planoDesativado(){
    if(!this.filtro || !this.filtro.cartao) return false;

    return  !this.filtro.cartao.plano.ativo
  }

  porReais() {
    return this.filtro.cartao && this.filtro.cartao.plano.tipoDeAcumulo === EnumTipoDeCartao.Reais;
  }

  porPontos() {
    return this.filtro.cartao && this.filtro.cartao.plano.tipoDeAcumulo === EnumTipoDeCartao.Pontos;
  }

  voltar() {
    this._location.back();
  }

  verCartao(contato: any) {
    this.router.navigateByUrl('/cliente/' + contato.id + "/" + this.filtro.cartao.id).then( () => { });
  }

  remover(contato: any) {
    this.abraDialogo = true;
  }

  apagueiContato() {
    this.router.navigateByUrl('/admin/contatos').then( () => { });
  }

  abraTelaNovoContato() {
    this.router.navigateByUrl('/admin/contatos/novo?nome=' + this.nomeContato + '&tel=' + this.telefone)
      .then( () => { });
  }

  eventoSalvouContato(contato: any) {
    this.contato = contato;
  }

  alterouDesativarEnvioMsgMarketing(ativado: any) {
    this.respServerAlterouAtivarDesativar = null;

    this.contatosService.ativarEnvioDeMensagemDeMkt(this.contato, ativado).then( (mensagem) => {
      this.respServerAlterouAtivarDesativar = {
        sucesso: true,
        mensagem: mensagem
      };
    }).catch( (erro) => {
      this.respServerAlterouAtivarDesativar = {
        sucesso: false,
        mensagem: erro
      };
    });
  }

  alterouTag(tag: string){
    console.log(this.tagSelecionada)
    delete this.novaTag;

    if(tag && tag.trim() === '') return;


    this.tagSelecionada = this.tags.find((item: any) => item.nome.toUpperCase() === tag.toUpperCase());

    if(! this.tagSelecionada)
      this.novaTag = { nome: tag}
  }

  async salveTag(){
    if(!this.novaTag || !this.novaTag.nome){
       delete this.novaTag;
       return;
    }

    this.salvandoTag = true;
    this.empresasService.salveTag(this.empresa,  this.novaTag).then((tag) => {
       delete this.novaTag;
       this.tags.push(tag)
       this.adicioneTagContato(this.contato, tag);
    }).catch((erro) => {
      this.salvandoTag = false;
       alert('Erro salvar nova tag: ' + erro)
    })
  }

  async adicioneTagSelecionada(){

    await this.adicioneTagContato(this.contato, this.tagSelecionada)
  }

  async adicioneTagContato(contato: any, tag: any){
    this.salvandoTag = true;
    this.contatosService.adicioneTag(contato, tag).then((resp) => {
      this.salvandoTag = false;
      this.contato.tags.push(tag)
    }).catch((erro) => {
      this.salvandoTag = false;
      alert('Erro adicionar tag: ' + erro)
    })
  }
}
